import {BusinessModelResponse, BusinessTimeBlockCollectionResponse} from "@/types/service-response";

export default class BusinessTimeBlockCollection {
  private constructor(
      readonly business: BusinessModelResponse,
      readonly createdAt: string,
      readonly id: string,
      readonly order: number,
      readonly title: string,
      readonly reservationDeadline: string,
      readonly deadlineForPreviousDay: boolean
  ) {}


  static createFromResponse(responseData: BusinessTimeBlockCollectionResponse): BusinessTimeBlockCollection {
    return new BusinessTimeBlockCollection(
        responseData.business,
        responseData.createdAt,
        responseData.id,
        responseData.order,
        responseData.title,
        responseData.reservationDeadline,
        responseData.deadlineForPreviousDay
    )
  }

  static createFromResponseList(responseData: BusinessTimeBlockCollectionResponse[]): BusinessTimeBlockCollection[] {
    return responseData.map((item:BusinessTimeBlockCollectionResponse) => {
      return new BusinessTimeBlockCollection(
          item.business,
          item.createdAt,
          item.id,
          item.order,
          item.title,
          item.reservationDeadline,
          item.deadlineForPreviousDay
      )
    })
  }


  public updateOrder (order: number): BusinessTimeBlockCollection {
    return new BusinessTimeBlockCollection(
        this.business,
        this.createdAt,
        this.id,
        order,
        this.title,
        this.reservationDeadline,
        this.deadlineForPreviousDay
    )
  }
}